/* Плавающая панель добавления в корзину на странице товара.
   Вынесено из inline <script> сниппета floating-cart-panel (~10,9 KB на PDP).
   Дополнительно: обработчик скролла ограничен одним вызовом на кадр и не
   читает геометрию, пока панель скрыта; MutationObserver цены сгруппирован —
   это убирает основной источник forced reflow на странице товара. */
(function() {
  'use strict';

  const FloatingPanel = {
    selectors: {
      scopeContainer: '.product-single__meta',
      addButton: 'button[name="add"][data-add-to-cart]',
      variantSelect: 'select[name="id"][data-product-select]',
      quantityInput: 'input[name="quantity"]',
      visiblePrice: '.artline-price__main, [data-excl-price], .b2b-prices__amount',
      visibleCompare: '.artline-price__compare, [data-excl-compare]',
      vatExclBlock: '[data-vat-excl-block]'
    },
    elements: {
      scope: null,
      addButton: null,
      variantSelect: null,
      quantityInput: null,
      priceElement: null,
      compareElement: null,
      panel: null
    },
    userClosed: false,
    init() {
      this.elements.scope = document.querySelector(this.selectors.scopeContainer) || document;
      this.elements.addButton = this.elements.scope.querySelector(this.selectors.addButton);
      this.elements.variantSelect = this.elements.scope.querySelector(this.selectors.variantSelect);
      this.elements.quantityInput = this.elements.scope.querySelector(this.selectors.quantityInput);
      this.elements.priceElement = this.elements.scope.querySelector(this.selectors.visiblePrice);
      this.elements.compareElement = this.elements.scope.querySelector(this.selectors.visibleCompare);
      this.elements.panel = document.getElementById('floating-cart-panel');
      this.elements.imageElement = document.getElementById('fcp-image');
      this.elements.footer = document.querySelector('.site-footer');
      this.isVatExcl = !!this.elements.scope.querySelector(this.selectors.vatExclBlock);

      if (!this.elements.addButton || !this.elements.panel) return;

      this.bindEvents();
      this.setupObserver();
      this.observePriceChanges();
      this.setupOverlayWatcher();
      this.setupImageWatcher();
      this.update();

      window.addEventListener('resize', () => this.updatePanelOffsetVar());
      let footerCollisionResizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(footerCollisionResizeTimer);
        footerCollisionResizeTimer = setTimeout(() => this.checkFooterCollision(), 120);
      });
    },
    bindEvents() {
      const fcpAdd = document.getElementById('fcp-add-to-cart');
      if (fcpAdd) {
        fcpAdd.addEventListener('click', () => {
          if (!this.isAvailable()) return;
          this.elements.addButton.click();
        });
      }
      const fcpClose = document.getElementById('fcp-close');
      if (fcpClose) {
        fcpClose.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.userClosed = true;
          this.hide();
        });
      }
      if (this.elements.variantSelect) {
        this.elements.variantSelect.addEventListener('change', () => {
          setTimeout(() => this.update(), 200);
        });
      }
      if (this.elements.quantityInput) {
        this.elements.quantityInput.addEventListener('change', () => this.update());
        this.elements.quantityInput.addEventListener('input', () => this.update());
      }
    },
    setupOverlayWatcher() {
      const chatToggle = document.querySelector('.mobile-bar__chat-toggle');
      const html = document.documentElement;

      const checkOverlay = () => {
        const drawerOpen = html.classList.contains('js-drawer-open');
        const chatOpen = chatToggle && chatToggle.getAttribute('aria-expanded') === 'true';
        if (drawerOpen || chatOpen) {
          this.elements.panel.classList.add('is-overlay-active');
        } else {
          this.elements.panel.classList.remove('is-overlay-active');
        }
        this.updatePanelOffsetVar();
      };

      const htmlObserver = new MutationObserver(checkOverlay);
      htmlObserver.observe(html, { attributes: true, attributeFilter: ['class'] });

      if (chatToggle) {
        const chatObserver = new MutationObserver(checkOverlay);
        chatObserver.observe(chatToggle, { attributes: true, attributeFilter: ['aria-expanded'] });
      }

      checkOverlay();
    },
    setupImageWatcher() {
      const onVariantEvent = (e) => {
        const variant = e.detail && e.detail.variant;
        this.updateVariantImage(variant);
      };
      document.addEventListener('variant:change', onVariantEvent);
      this.elements.scope.addEventListener('variantChange', onVariantEvent);
    },
    updateVariantImage(variant) {
      if (!this.elements.imageElement) return;

      let src = null;
      if (variant && variant.featured_image) {
        src = typeof variant.featured_image === 'string'
          ? variant.featured_image
          : variant.featured_image.src;
      }

      if (!src) {
        src = this.elements.imageElement.getAttribute('data-default-image');
      }

      if (src && !src.includes('width=')) {
        src += (src.includes('?') ? '&' : '?') + 'width=200';
      }

      if (src) this.elements.imageElement.src = src;
    },
    setupObserver() {
      let threshold = null;

      const computeThreshold = () => {
        const rect = this.elements.addButton.getBoundingClientRect();
        threshold = window.scrollY + rect.top + rect.height + 20;
      };

      const checkScroll = () => {
        if (threshold === null) computeThreshold();
        if (window.scrollY > threshold) {
          this.show();
        } else {
          this.userClosed = false;
          this.hide();
        }
        // Пока панель скрыта, читать геометрию футера и её собственную высоту
        // незачем: это принудительный пересчёт лейаута на каждом кадре скролла.
        if (this.elements.panel.classList.contains('is-visible')) {
          this.checkFooterCollision();
          this.updatePanelOffsetVar();
        }
      };

      // Обработчик скролла выполняется не чаще одного раза за кадр, иначе
      // чтения getBoundingClientRect/offsetHeight идут десятками за кадр.
      let scrollScheduled = false;
      const onScroll = () => {
        if (scrollScheduled) return;
        scrollScheduled = true;
        requestAnimationFrame(() => {
          scrollScheduled = false;
          checkScroll();
        });
      };

      computeThreshold();
      checkScroll();

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        computeThreshold();
        checkScroll();
      });
      window.addEventListener('load', () => {
        computeThreshold();
        checkScroll();
      });
    },
    observePriceChanges() {
      const target = this.elements.scope;
      if (!target) return;
      let updateScheduled = false;
      const observer = new MutationObserver(() => {
        if (updateScheduled) return;
        updateScheduled = true;
        requestAnimationFrame(() => {
          updateScheduled = false;
          this.update();
        });
      });
      observer.observe(target, {
        childList: true, characterData: true, subtree: true
      });
    },
    update() {
      const variantName = this.getSelectedVariant();
      const price = this.getPrice();
      const compare = this.getComparePrice();
      const isAvailable = this.isAvailable();

      const variantEl = document.getElementById('fcp-variant');
      const priceEl = document.getElementById('fcp-price');
      const compareEl = document.getElementById('fcp-compare');
      const vatNoteEl = document.getElementById('fcp-vat-note');
      const addBtn = document.getElementById('fcp-add-to-cart');

      if (variantEl && variantName) variantEl.textContent = variantName;
      if (priceEl && price) priceEl.textContent = price;
      if (compareEl) compareEl.textContent = compare || '';
      if (priceEl) priceEl.classList.toggle('is-sale', !!compare);
      if (vatNoteEl) {
        var vatTextEl = document.getElementById('fcp-vat-note-text');
        if (this.isVatExcl) {
          if (vatTextEl) vatTextEl.textContent = 'VAT excl.';
          vatNoteEl.style.display = '';
        } else {
          vatNoteEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !isAvailable;

      this.updatePanelOffsetVar();
    },
    getSelectedVariant() {
      if (!this.elements.variantSelect) return null;
      const selected = this.elements.variantSelect.selectedOptions[0];
      if (!selected) return null;
      return selected.textContent.trim().split(' - ')[0].trim();
    },
    getPrice() {
      if (!this.elements.priceElement || !document.contains(this.elements.priceElement)) {
        this.elements.priceElement = this.elements.scope.querySelector(this.selectors.visiblePrice);
      }
      return this.elements.priceElement ? this.elements.priceElement.textContent.trim() : null;
    },
    getComparePrice() {
      if (!this.elements.compareElement || !document.contains(this.elements.compareElement)) {
        this.elements.compareElement = this.elements.scope.querySelector(this.selectors.visibleCompare);
      }
      return this.elements.compareElement ? this.elements.compareElement.textContent.trim() : null;
    },
    isAvailable() {
      return !this.elements.addButton?.disabled;
    },
    show() {
      if (this.userClosed) return;
      this.elements.panel.classList.add('is-visible');
      this.updatePanelOffsetVar();
    },
    hide() {
      this.elements.panel.classList.remove('is-visible');
      this.elements.panel.classList.remove('is-docked');
      this.elements.panel.style.top = '';
      document.documentElement.style.setProperty('--fcp-panel-offset', '0px');
    },
    getPanelBottomMargin() {
      if (window.innerWidth <= 999) {
        const mobileBarHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--mobile-bar-height')
        ) || 0;
        return mobileBarHeight + (window.innerWidth < 768 ? 12 : 24);
      }
      return 24;
    },
    checkFooterCollision() {
      if (window.innerWidth < 768) {
        if (this.elements.panel && this.elements.panel.classList.contains('is-docked')) {
          this.elements.panel.style.top = '';
          this.elements.panel.classList.remove('is-docked');
        }
        return;
      }
      if (!this.elements.footer || !this.elements.panel) return;
      if (!this.elements.panel.classList.contains('is-visible')) return;

      const footerRect = this.elements.footer.getBoundingClientRect();
      const margin = this.getPanelBottomMargin();
      const panelHeight = this.elements.panel.offsetHeight;
      const overlapsFooter = footerRect.top < (window.innerHeight - margin);

      if (overlapsFooter) {
        const dockedTop = window.scrollY + footerRect.top - panelHeight - margin;
        this.elements.panel.style.top = dockedTop + 'px';
        this.elements.panel.classList.add('is-docked');
      } else {
        this.elements.panel.style.top = '';
        this.elements.panel.classList.remove('is-docked');
      }
    },
    updatePanelOffsetVar() {
      requestAnimationFrame(() => {
        if (!this.elements.panel.classList.contains('is-visible') ||
            this.elements.panel.classList.contains('is-overlay-active')) {
          document.documentElement.style.setProperty('--fcp-panel-offset', '0px');
          return;
        }
        const h = this.elements.panel.offsetHeight;
        document.documentElement.style.setProperty('--fcp-panel-offset', h + 'px');
        this.checkFooterCollision();
      });
    }
  };

  function initPanel() {
    FloatingPanel.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPanel);
  } else {
    setTimeout(initPanel, 100);
  }

  window.FloatingPanel = FloatingPanel;
})();
